import React from 'react';
import ArticleTags from '../molecules/ArticleTags/ArticleTags';

const withArticleTags = (WrappedComponent, showTags = true) => (props) => {
  const { article, onTagRemove, onAddTags, onTagClick, ...rest } = props;

  return (
    <WrappedComponent
      {...rest}
      article={article}
      onTagRemove={onTagRemove}
      onAddTags={onAddTags}
      onTagClick={onTagClick}
      {...(typeof WrappedComponent === 'function' && WrappedComponent.name && WrappedComponent.name.startsWith('Article')
        ? {
            renderTags:
              showTags
                ? () => (
                    <ArticleTags
                      tags={article?.tags || []}
                      onTagRemove={onTagRemove ? (tag) => onTagRemove(article._id, tag) : undefined}
                      onTagClick={onTagClick ? (tag) => onTagClick(tag, article) : undefined}
                    />
                  )
                : undefined
          }
        : {})}
    />
  );
};

export default withArticleTags; 